<template>
  <v-app>
    <v-content>
      <v-container fluid>
        <v-layout align-center justify-center>
          <v-card style="max-width: 90%">
            <v-responsive :aspect-ratio="16 / 9">
              <v-card-title primary-title>
                <div>
                  <div class="headline pl-2 pa-1">{{ $t("maps.createSeasonalReservation.heading") }}</div>
                </div>
              </v-card-title>
              <v-form ref="form" v-model="form" class="pa-4 pt-6">
                <v-text-field
                      outline
                      v-model="model.day"
                      :rules="[rules.required]"
                      :label="$t('maps.createSeasonalReservation.day')"
                      type="date"
                    ></v-text-field>
                <div class="time-container">
                  <div class="time-left">
                    <!-- Left column content -->
                    <div>
                      <span>{{ $t("maps.createSeasonalReservation.from") }}</span>
                      <br />
                      <v-time-picker outline v-model="model.start_time" :allowed-minutes="allowedMinutes"
                        elevation="15"></v-time-picker>
                    </div>
                  </div>
                  <div class="time-right">
                    <!-- Right column content -->
                    <div>
                      <span>{{ $t("maps.createSeasonalReservation.to") }}</span>
                      <br />
                      <v-time-picker outline v-model="model.end_time" :allowed-minutes="allowedMinutes"
                        elevation="15"></v-time-picker>
                    </div>
                  </div>
                </div>

                <v-btn :loading="loading" block @click="createSeasonalTime" color="secondary" dark>{{ $t("common.create") }}</v-btn>
              </v-form>
            </v-responsive>
          </v-card>
        </v-layout>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import axios from "axios";

export default {
  title() {
    return this.$t("maps.createSeasonalReservation.title");
  },
  data: () => ({
    model: {
      day: "",
      start_time: "05:00",
      end_time: "09:00",
    },

    loading: false,
    form: false,
  }),

  computed: {
    rules() {
      return {
        length: (len) => (v) =>
          (v || "").length >= len || this.$t("maps.createSeasonalReservation.invalidLength", { len }),
        required: (v) => !!v || this.$t("common.required"),
      };
    },
  },


  methods: {
    allowedMinutes: (v) => v == 15 || v == 30 || v == 45 || v == 0,
    createSeasonalTime() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        console.log(22)
        if (this.model.end_time <= this.model.start_time) {
          window.getApp.$emit(
            "SHOW_TOAST",
            this.$t("maps.createSeasonalReservation.enterValidHours"),
            "red"
          );
          this.loading = false;

          return;
        }
        this.axios
          .post(this.api.ACTIONS.SEASONAL_RESERVATIONS, {
            ...this.model,
            provider: "users",
          })
          .then(() => {
            window.getApp.$emit("SHOW_TOAST", this.$t("maps.createSeasonalReservation.createdSuccessfully"), "green");
            this.$router.push("/seasonal_reservations");
          })
          .catch((err) => {
            console.log(err.message);
            this.error = true;
            let response = err.response;
            if (response) {
              window.getApp.$emit("SHOW_TOAST", response.data.message, "red");
              console.log(response.data);
            } else {
              window.getApp.$emit("SHOW_TOAST", this.$t("maps.createSeasonalReservation.checkYourInfo"), "red");
            }
          })
          .then(() => (this.loading = false));
      }
      console.log(this.model);
      // }
    },
  },
};
</script>

<style scoped>
.time-container {
  display: flex;
}

.time-left,
.time-right {
  flex: 1;
  padding: 10px;
}
</style>
